module.exports = __webpack_public_path__ + "static/media/lunch-cropped.bb684c6b.jpeg";